// Centralized API configuration
export const API_BASE_URL = import.meta.env.VITE_BACKEND_URL;
if (!import.meta.env.VITE_BACKEND_URL) {
  throw new Error("VITE_BACKEND_URL is not defined");
}
console.log("🌍 VITE_BACKEND_URL =", import.meta.env.VITE_BACKEND_URL);
console.log("🌍 API_BASE_URL =", API_BASE_URL);
export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/tenantRegistration/login`,
  REGISTER: `${API_BASE_URL}/tenantRegistration/register`,
  ME: `${API_BASE_URL}/tenantRegistration/me`,
  FORGOT_PASSWORD: `${API_BASE_URL}/tenantRegistration/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL}/tenantRegistration/reset-password`,

  JOBS: `${API_BASE_URL}/jobs`,
  JOB_BY_ID: (id: string) => `${API_BASE_URL}/jobs/${id}`,
  JOB_STATS: `${API_BASE_URL}/jobs/stats`,
  JOB_STATUS: (id: string) => `${API_BASE_URL}/jobs/${id}/status`,

  TENANT_USERS: `${API_BASE_URL}/tenant/users`,
  TENANT_USER_BY_ID: (id: number | string) => `${API_BASE_URL}/tenant/users/${id}`,
  TENANT_USER_STATUS: (id: number | string) => `${API_BASE_URL}/tenant/users/${id}/status`,

  APPLICANTS: `${API_BASE_URL}/applicants`,
  APPLICANT_BY_ID: (id: number | string) => `${API_BASE_URL}/applicants/${id}`,
  APPLICANT_STATUS: (id: number | string) => `${API_BASE_URL}/applicants/${id}/status`,

  APPLICATIONS: `${API_BASE_URL}/applications`,
  APPLICATION_BY_ID: (id: string | string) => `${API_BASE_URL}/applications/${id}`,
  APPLICATION_STATUS: (id: string | string) => `${API_BASE_URL}/applications/${id}/status`,
  APPLICATION_APPLICANT: (id: string | string) => `${API_BASE_URL}/applications/${id}/applicant`,
  APPLICATION_FROM_RESULT: `${API_BASE_URL}/applications/from-result`,
  APPLICATION_DETAILS: (id: string) => `${API_BASE_URL}/applications/details/${id}`,
};
